import React, {createContext} from "react";
import {Route, Routes, useLocation} from "react-router-dom";
import MainPage from "./pages/MainPage";
import SideBar from "./components/mainpage/SideBar";
import Detailed from "./components/mainpage/Detailed";
import Ranges from "./components/mainpage/Ranges";
import NotExistPage from "./pages/NotExistPage";
import usePersistedLanguage from "./hooks/usePersistedLanguage";

import './index.css';
import JoinPage from "./pages/JoinPage";

import MariupolPage from "./pages/MariupolPage";
import MariupolSideBar from "./components/mariupolpage/MariupolSideBar";
import MariupolDetailed from "./components/mariupolpage/MariupolDetailed";
import YearPage from "./pages/YearPage";
import AddYearPage from "./pages/AddYearPage";
import AddPhotoYearPage from "./pages/AddPhotoYearPage";
import YearPhotoPage from "./pages/YearPhotoPage";

export const LanguageContext = createContext();

const App = () => {
    const location = useLocation()
    if (window.location.host === 'remap-ru.onrender.com') {
        window.location.href = 'https://remap-ru.com';
    }
    const [language, toggler] = usePersistedLanguage(location.pathname.split('/')[1] === 'en' ? 'en':'ru');

    return (
        <LanguageContext.Provider value={{language, toggler}}>
            <Routes>
                {/*/!*  Main pages  *!/*/}
                {/*<Route path="/" element={<Navigate replace to={language.name}/>}/>*/}


                <Route path="/" element={<MainPage/>}>
                    <Route path='/' element={<SideBar/>}>
                        <Route path=":slug" element={<Detailed/>}/>
                    </Route>
                    <Route path="range" element={<SideBar/>}/>
                    <Route path="ranges" element={<Ranges/>}/>

                    {/*<Route path=':city' element={<SideBar/>}>*/}
                    {/*    <Route path=":slug" element={<Detailed/>}/>*/}
                    {/*</Route>*/}
                </Route>
                <Route path="join" element={<JoinPage/>}/>


                <Route path="en" >
                    <Route path="" element={<MainPage/>}>
                        <Route path="" element={<SideBar/>}>
                            <Route path=":slug" element={<Detailed/>}/>
                        </Route>
                        <Route path="range" element={<SideBar/>}/>
                        <Route path="ranges" element={<Ranges/>}/>
                    </Route>

                    <Route path="join" element={<JoinPage/>}/>

                </Route>

                <Route path="m5000" element={<MariupolPage/>}>
                    <Route path="" element={<MariupolSideBar/>}>
                        <Route path=":slug" element={<MariupolDetailed/>}/>
                    </Route>
                </Route>

                <Route path="360" element={<YearPage/>}>

                    {/*<Route path="" element={<MariupolSideBar/>}>*/}
                    {/*    <Route path=":slug" element={<MariupolDetailed/>}/>*/}
                    {/*</Route>*/}
                </Route>
                <Route path="360/add" element={<AddYearPage/>}/>
                <Route path="360/add/photo" element={<AddPhotoYearPage/>}/>
                <Route path="360/photos" element={<YearPhotoPage/>}/>


                {/*<Route path='/en' element={<SideBar/>}>*/}
                {/*    <Route path=":slug" element={<Detailed/>}/>*/}
                {/*</Route>*/}
                {/*<Route path="range" element={<SideBar/>}/>*/}
                {/*<Route path="ranges" element={<Ranges/>}/>*/}


                {/*  Other pages  */}
                {/*<Route path='/join' element={<JoinPage/>}/>*/}
                {/*<Route path='/404' element={<NotExistPage/>}/>*/}
                {/*<Route path='*' element={<NotExistPage/>}/>*/}

            </Routes>

        </LanguageContext.Provider>
    )
}

export default App